import styled from 'styled-components'

import { Box } from '../../components/Box'
import { Flex } from '../../components/Flex'
import { Image } from '../../components/Image'
import { themeColor } from '../../components/theme'

const Container = styled(Flex)<{ backgroundColor?: string; textColor: string }>`
  background: ${p => p.backgroundColor || themeColor('bgPrimary')(p)};
  border-radius: 4px;
  overflow: hidden;

  p {
    margin: 0;
  }

  .rich-text-content {
    p {
      color: ${p => (p.textColor === 'Light' ? themeColor('white')(p) : themeColor('darkGray')(p))};
    }
  }
`

const BannerImg = styled(Image)`
  max-width: 100%;
`

const BackgroundContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  img {
    height: 80px;
  }
`

type InlineBannerProps = {
  data: {
    title: string
    description: string
    link?: {
      url: string
      text: string
      target: string
    }
    image?: {
      url: string
      altText?: string
    }
    textColor: string
    backgroundColor?: string
  }
}

export const InlineBanner = ({ data }: InlineBannerProps) => {
  const hasImage = !!data.image
  return (
    <Container flexWrap="wrap" backgroundColor={data.backgroundColor} textColor={data.textColor}>
      <Box width={[1, 1, hasImage ? 1 / 2 : 3 / 4, hasImage ? 3 / 5 : 4 / 5]} p={3} pb={[1, 1, 3]}>
        <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: data.description }} />
      </Box>
      {hasImage && (
        <Box
          width={[1 / 2, 1, 1 / 4, 1 / 5]}
          px={3}
          display="flex"
          alignItems="center"
          justifyContent={['flex-start', 'flex-start', 'center']}
        >
          <BannerImg src={data.image?.url} alt={data.image?.altText} />
        </Box>
      )}
      <BackgroundContainer width={[hasImage ? 1 / 2 : 1, hasImage ? 1 / 2 : 1, 1 / 4, 1 / 5]}>
        <Image type="searchBannerBackground" />
      </BackgroundContainer>
    </Container>
  )
}
